// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  max-height: calc(100vh - 400px);
  overflow: auto;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/confirm-dialog/ConfirmDialog.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,cAAA;EACA,cAAA;AACJ","sourcesContent":[".error-container{\n    max-height: calc(100vh - 400px);\n    overflow: auto;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
